import React, { lazy, Suspense } from 'react';
import Navbar from '../../components/layout/Navbar';
import Header from '../../components/sections/Header';
import DSADisclosure from '../../components/sections/DSADisclosure';

// Lazy load components below the fold for better performance
const Services = lazy(() => import('../../components/sections/Services'));
const LoanBenefits = lazy(() => import('../../components/sections/LoanBenefits'));
const Eligibility = lazy(() => import('../../components/sections/Eligibility'));
const CTA = lazy(() => import('../../components/sections/CTA'));
const LeadForm = lazy(() => import('../../components/sections/LeadForm'));
const FAQ = lazy(() => import('../../components/sections/FAQ'));
const Footer = lazy(() => import('../../components/layout/Footer'));

// Loading placeholder
const LoadingPlaceholder = () => (
  <div className="py-20 flex justify-center items-center">
    <div className="animate-pulse text-gray-400">Loading...</div>
  </div>
);

const LandingPage = () => {
  return (
    <div className="min-h-screen">
      <Navbar />
      <Header />
      <DSADisclosure />
      <Suspense fallback={<LoadingPlaceholder />}>
        <Services />
        <LoanBenefits />
        <Eligibility />
        <CTA />
        <LeadForm />
        <FAQ />
        <Footer />
      </Suspense>
    </div>
  );
};

export default LandingPage;


